// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_CAN_BILL_CRED, SUC_CAN_BILL_CRED } from '../../../../utils/strings';

const useCancelCredentialBilling = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_CancelCredentialBilling,
    SUC_CAN_BILL_CRED,
    ERR_CAN_BILL_CRED,
  );

  return submit;
};

export default useCancelCredentialBilling;
